import React from "react";
import Image from "next/image";
import { HeadingText, BodyText } from "src/components/owlet-typography";
import { OwletActionButton } from "src/components/owlet-action-button";

interface OwletEmptyStateProps {
  onGetCare?: () => void;
  isProcessing?: boolean;
  className?: string;
}

export function OwletEmptyState({
  onGetCare,
  isProcessing = false,
  className = "",
}: OwletEmptyStateProps) {
  return (
    <div className={className}>
      {/* Card with Image and Content */}
      <div className="flex flex-col overflow-hidden rounded-2xl bg-surface">
        {/* Hero Image */}
        <div className="relative h-[240px] w-full shrink-0">
          <Image
            src="/icons/empty-state-bg.png"
            alt="Mother with child"
            fill
            className="object-cover"
            priority
            sizes="100vw"
          />
        </div>

        {/* Content Section */}
        <div className="flex flex-col w-full px-6 pt-6 pb-6 gap-6">
          <HeadingText className="text-on-surface">
            Start a visit with a pediatrician for symptom support and treatment
          </HeadingText>

          {/* Checkmark List */}
          <div className="flex flex-col gap-4">
            <div className="flex items-start gap-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 text-purple-accent"
              >
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <BodyText className="text-on-surface">No appointments</BodyText>
            </div>
            <div className="flex items-start gap-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 text-purple-accent"
              >
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <BodyText className="text-on-surface">
                Prescriptions available
              </BodyText>
            </div>
            <div className="flex items-start gap-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 text-purple-accent"
              >
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <BodyText className="text-on-surface">
                Diagnosis in under an hour
              </BodyText>
            </div>
          </div>

          {/* Button */}
          <OwletActionButton
            onPress={onGetCare || (() => {})}
            disabled={isProcessing}
            variant="primary"
            className="w-full"
          >
            {isProcessing ? (
              <div className="animate-spin h-4 w-4 border-2 border-on-action-primary border-t-transparent rounded-full"></div>
            ) : (
              "Send Symptoms for Review"
            )}
          </OwletActionButton>
        </div>
      </div>
    </div>
  );
}
